<div @fade class="container-terms-and-conditions" [ngClass]="{'rapidScore': isRapidScore}"
  [ngStyle]="{'grid-template-rows': +showIcon === 3 ? 'auto' : '100px 100px auto'}">
  <header *ngIf="+showIcon !== 3" class="header" role="banner">
    <div class="container-logo">
      <div class="logo"><img
          src="{{ showIcon === 1 ? './assets/temporals/Logo_Akana_Azul.png' : './assets/logos/Logo_SCF_red.png' }}"
          [ngStyle]="{'cursor':  showIcon === 1 ? 'pointer' : 'auto', 'width': showIcon !== 1 ? '130px' : '95px'}"
          (click)="goToHome(showIcon === 1)" alt=""></div>
      <div class="faqs" (click)="saveUrl()" *ngIf="showIcon !== '4' && !isRapidScore" >
        <p>{{'FAQS.NAME' | translate}}</p> &nbsp;&nbsp;&nbsp;<img src="./assets/logos/faq.svg" alt="">
      </div>
    </div>
    <div class="language-selector-container">
      <app-language-selector></app-language-selector>
    </div>
  </header>
  <div class="sub-tittle" role="complementary">
    <h1>{{'TERMS.TITLEH2' | translate}}</h1>
    <hr>
  </div>
  <div class="left" *ngIf="!isRapidScore" role="complementary">
    <img src="./assets/temporals/termsAndConditions_img.svg" alt="">
  </div>
  <div class="right" role="main">
    <div class="information-tittle">
      <p [innerHTML]="'TERMS.TITTLE' | translate"></p>
    </div>
    <div class="container-form-terms">
      <div class="form-terms">
        <form action="" [formGroup]="termsForm">
          <div class="input-control-error" *ngIf="termsForm.controls.email">
            <input type="text" [ngClass]="{'error-input': validations() }" formControlName="email" class="input-search"
              name="" placeholder="Introduce un email" id="email" aria-label="email">
            <div class="div-error"
              *ngIf="termsForm.controls.email.value && termsForm.invalid && termsForm.controls.email.touched">
              {{ 'TERMS.ERRORS.EMAIL_VALID' | translate }}
            </div>
            <div class="div-error" *ngIf="!termsForm.controls.email.value && termsForm.controls.email.touched"
              [innerHTML]=" 'TERMS.ERRORS.EMAIL_REQUIRED' | translate">
            </div>
          </div>
          <div *ngIf="hiddeCommercialConditions" id="ofersId" class="container-checkbox">
            <mat-checkbox formControlName="ofers" (click)="analiticsGoogle()" aria-label="comercial"></mat-checkbox>
            <p>{{'TERMS.CONDITIONS.CHECK_2' | translate}}</p>
          </div>
          <div class="container-checkbox">
            <div (click)="openWarmModal()">
              <mat-checkbox id="termsId"  formControlName="termsAndConditions" aria-label="terminos">
              </mat-checkbox>
            </div>
            <p>{{'TERMS.CONDITIONS.CHECK_1' | translate}}
              <strong (click)="navigateToUrl('terms-conditions')"
                class="text-box">{{'TERMS.CONDITIONS.CHECK_TERMS_1' | translate}}</strong>{{'TERMS.CONDITIONS.CHECK_BETWEEN' | translate }}
              <strong (click)="navigateToUrl('privacy-polity')"
                class="text-box">{{ 'TERMS.CONDITIONS.CHECK_POLITY' | translate}}</strong>{{'TERMS.CONDITIONS.CHECK_FINAL' | translate}}
            </p>
          </div>
          <div class="disclaimer-checkbox" *ngIf="isRapidScore && hiddeCommercialConditions">
            <span class="exclamation">!</span>  {{'TERMS.MSGWARNING' | translate}}
          </div>
        </form>
      </div>
      <div class="btn-container">
        <button *ngIf="showProgress" id="agreeButton" aria-label="Continuar"
          [ngClass]="{'btn-disabled': !valid || termsForm.errors, 'enable': valid && termsForm.valid }"
          [disabled]="!valid || termsForm.errors"
          (click)="onSubmit()">{{ 'TERMS.BUTTONS.CONTINUE' | translate }}</button>
        <mat-progress-bar [ngClass]="{'rapidScore': isRapidScore}" style="width: 95%; margin: 0 auto; max-width: 350px;" *ngIf="!showProgress"
          mode="indeterminate">
        </mat-progress-bar>
      </div>
      <div *ngIf="activatedTest" style="text-align: right;">
        <small>Test activado</small>
      </div>
    </div>
  </div>
  <app-footer *ngIf="+showIcon !== 3 && !isRapidScore" class="footer" [colorItems]="'#ffffff'" [classSpecial]="true" role="contentinfo"></app-footer>
</div>
